/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Fri Oct 13 2023
 **/

import { useMemo } from "react";

function byteLength(value: BlobPart[]) {
	return new Blob(value).size;
}

function isArrayBlobPart(blob: BlobPart | BlobPart[]): blob is BlobPart[] {
	return !(
		blob instanceof ArrayBuffer ||
		blob instanceof Blob ||
		typeof blob === "string" ||
		(blob instanceof Object && "buffer" in blob && blob.buffer instanceof ArrayBuffer)
	);
}

export default function useByteCheck(maxByte: number, value: BlobPart | BlobPart[]) {
	const byteSize = useMemo(() => (isArrayBlobPart(value) ? byteLength(value) : byteLength([value])), [value]);

	const isOverLimit = useMemo(() => byteSize > maxByte, [byteSize, maxByte]);

	return { isOverLimit, byteSize };
}
